import { memo } from "react";
import { IconTypes } from "../../../../enums";
import { useTranslation } from "../../../../hooks";

interface StatusProps {
  status: string;
  className: string;
  icon: IconTypes;
}

const Status: React.FC<StatusProps> = ({ status, icon, className }) => {
  const t = useTranslation();

  return (
    <div className={`qrTicketStatus ${className}`}>
      <span className="ticketStatus">{t(status)}</span>
      <i className={`${icon} ticketStatusIcon`} />
    </div>
  );
};

export default memo(Status);
